var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "new-messenger-channel-form" } },
    [
      _c("a-form", [
        _c(
          "div",
          { staticClass: "form-wrapper" },
          [
            _c(
              "div",
              { staticClass: "input-wrapper d-none" },
              [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("whatsappChannel.channelName"))),
                ]),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  {
                    attrs: {
                      "validate-status": _vm.getErrorStatus("channelName"),
                      help: _vm.getErrorMessage("channelName"),
                    },
                  },
                  [
                    _c("a-input", {
                      ref: "channelName",
                      attrs: {
                        placeholder: this.$t("whatsappChannel.channelName"),
                        name: "channelName",
                      },
                      model: {
                        value: _vm.form.channelName,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "channelName", $$v)
                        },
                        expression: "form.channelName",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("strong", [
              _vm._v(" " + _vm._s(_vm.$t("message.messengerAddDesc")) + " "),
            ]),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("a-checkbox", {
                  attrs: { checked: _vm.termOfService },
                  on: {
                    change: function ($event) {
                      return _vm.acceptTermOfService("pp")
                    },
                  },
                }),
                _vm._v(" "),
                _c("b", [
                  _vm._v("I read and agree to "),
                  _c(
                    "a",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.acceptTermOfService("pp")
                        },
                      },
                    },
                    [_vm._v("Privacy Policy")]
                  ),
                  _vm._v(" and\n                    "),
                  _c(
                    "a",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.acceptTermOfService("tac")
                        },
                      },
                    },
                    [_vm._v("Terms and Conditions")]
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _vm.termOfServiceModal
              ? _c("TermOfService", {
                  attrs: { type: _vm.termOfServiceModal },
                  on: {
                    agree: _vm.acceptedTermOfService,
                    cancel: function ($event) {
                      _vm.termOfServiceModal = null
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.callbackResponse.accessToken
              ? _c("MessengerPageSelector", {
                  attrs: { pages: _vm.callbackResponse.pages },
                  model: {
                    value: _vm.selectedPage,
                    callback: function ($$v) {
                      _vm.selectedPage = $$v
                    },
                    expression: "selectedPage",
                  },
                })
              : _c(
                  "SupsisButton",
                  {
                    attrs: { primary: "", disabled: !_vm.termOfService },
                    on: { click: _vm.handleSubmit },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("messenger.connectMessenger"))
                    ),
                  ]
                ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-footer" }, [
        _c(
          "div",
          { staticClass: "actions" },
          [
            _c("a-button", { on: { click: _vm.handleCancel } }, [
              _vm._v(_vm._s(_vm.$t("message.cancel"))),
            ]),
            _vm._v(" "),
            _c(
              "a-button",
              {
                staticClass: "pr-confirm-btn",
                attrs: {
                  type: "primary",
                  disabled: !_vm.termOfService || _vm.loading,
                },
                on: { click: _vm.handleSubmit },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("mail.connect")) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }